<template>
    <Teleport to="body">
        <!-- No <transition> here: a transition inside a Teleport can crash on leave with
             "insertBefore of null" (and wedge visible in a hidden tab). Show/hide is instant. -->
        <div v-if="show" class="md-loader" :class="{ 'is-light': light }" role="alertdialog" aria-live="assertive" aria-busy="true">
            <div class="md-loader-backdrop"></div>
            <div class="md-loader-card" role="document">
                <div class="md-loader-head">
                    <img class="md-loader-logo" :src="logoSrc" alt="Markel" />
                </div>
                <div class="md-loader-body">
                    <h2 class="md-loader-title">{{ title }}</h2>
                    <div class="md-loader-spinner" aria-hidden="true">
                        <span v-for="i in 8" :key="i" class="dot" :style="dotStyle(i)"></span>
                    </div>
                    <p class="md-loader-text">{{ text }}</p>
                    <div v-if="button" class="md-loader-actions">
                        <a class="btn btn-primary" :href="url || '#'">Continue</a>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
// Markel Direct "Please wait" loader — a non-dismissable overlay shown while the quote is rated
// or the question set / journey loads. Self-contained; styling lives in assets/custom/_loader.scss
// (global, because the app is a light-DOM custom element and this teleports to <body>).
defineProps({
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Please wait' },
    text: { type: String, default: 'Do not refresh the page and wait while we are processing your information.' },
    button: { type: Boolean, default: false },
    url: { type: String, default: '' },
    light: { type: Boolean, default: false },
    logoSrc: { type: String, default: '/assets/images/markel-direct-logo-new.svg' },
})

// 8-dot circular spinner (the Markel Direct look): dots fade around the ring so the highlight chases.
function dotStyle(i: number) {
    const angle = (i - 1) * 45
    const opacity = 0.12 + ((i - 1) / 7) * 0.88
    return {
        transform: `rotate(${angle}deg) translateY(-15px)`,
        opacity: opacity.toFixed(2),
    }
}
</script>
